<template>
    <div class="card">
        <div class="card-image">
            <figure class="image is-4by3">
            <img :src="`/static/recipes/${ data.prev }`" />
            </figure>
        </div>
        <div class="card-content">
            <div class="content">
            <strong>{{ $t(data.name) }}</strong> 
            <span class="icon has-text-grey is-size-4">
                <i class="fa fa-clock-o"></i>
            </span> {{ data.time }}
            <br>
            <p>
                <strong>{{ 'Ingredients' | translate }}:</strong><br>
                <span v-for="(item, i) in data.ingredients" :key="i + 'Ingredients'">{{ $t(item) }}<br v-if="i < data.ingredients.length" /></span>
            </p>
            <p>
                {{ $t(data.desc) }}
                {{ 'Preparation' | translate }}: <br>
                <span v-for="(item, i) in data.preparation" :key="i + 'Preparation'">{{ i + 1 }}. {{ $t(item) }}<br/></span>

                {{ 'Portions' | translate }}: {{ data.portions }}
            </p>
            </div>
        </div>
    </div>
</template>


<script>
export default {
  name: 'Recipt',
  props: ['data'],
  data () {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Settings/Recipt.vue